import * as React from 'react';
import { green, pink } from '@mui/material/colors';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import FolderIcon from '@mui/icons-material/Folder';
import PageviewIcon from '@mui/icons-material/Pageview';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Link as RouterLink } from 'react-router-dom';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { Grid, Paper, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';

export default function MobileMenu() {
  const theme = useTheme();
  const appMode = useSelector((state) => state.mode.mode);
  
  const menuItems = [
    {
      title: 'Referrals',
      route: '/referrals',
      icon: 'https://res.cloudinary.com/dmzqkpypw/image/upload/v1738068352/gift_mjan0v.png',
      description: 'Invite Friends'
    },
    {
      title: 'Funding',
      route: '/account-wallet',
      icon: 'https://res.cloudinary.com/dmzqkpypw/image/upload/v1738068353/wallet_b7ymoh.png',
      description: 'Add Funds'
    },
    {
      title: 'Invest',
      route: '/package/Invest Funds',
      icon: 'https://res.cloudinary.com/dqi4rtyvh/image/upload/v1739919729/profits_atawbu.png',
      description: 'Investment Vehicle'
    },
    {
      title: 'Exchange',
      route: '/swap-coin',
      icon: 'https://res.cloudinary.com/dqi4rtyvh/image/upload/v1739863653/swap_vw5hqj.png',
      description: 'Currency Swap'
    },
    {
      title: 'DeFi',
      route: '/web3',
      icon: 'https://res.cloudinary.com/dqi4rtyvh/image/upload/v1738590761/web3_ztvzkf.png',
      description: 'Web3 Portal'
    },
    {
      title: 'Portfolio',
      route: '/assets',
      icon: 'https://res.cloudinary.com/dmzqkpypw/image/upload/v1738068347/wallet_1_vmr3li.png',
      description: 'Asset Overview'
    }
  ];

  return (
    <Box sx={{ px: 1, py: 1.5, mb: 1 }}>
      <Grid container spacing={1}>
        {menuItems.map((item, index) => (
          <Grid item xs={3} sm={4} md={2} key={index}>
            <Paper
              component={RouterLink}
              to={item.route}
              elevation={0}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '10px 6px',
                textDecoration: 'none',
                color: 'inherit',
                borderRadius: '16px',
                border: appMode === 'dark' 
                  ? '1px solid rgba(255,255,255,0.08)' 
                  : '1px solid rgba(0,0,0,0.06)',
                background: appMode === 'dark'
                  ? 'rgba(255,255,255,0.02)'
                  : 'rgba(0,0,0,0.01)',
                transition: 'all 0.2s ease',
                cursor: 'pointer',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: appMode === 'dark'
                    ? '0 4px 12px rgba(255,255,255,0.05)'
                    : '0 4px 12px rgba(0,0,0,0.08)',
                  border: appMode === 'dark'
                    ? '1px solid rgba(255,255,255,0.12)'
                    : '1px solid rgba(0,0,0,0.08)',
                  background: appMode === 'dark'
                    ? 'rgba(255,255,255,0.04)'
                    : 'rgba(0,0,0,0.02)',
                }
              }}
            >
              <Avatar 
                src={item.icon}
                sx={{ 
                  width: 32, 
                  height: 32,
                  mb: 0.5,
                  padding: '4px',
                  background: 'transparent',
                  border: 'none',
                  boxShadow: 'none',
                }}
              />
              
              <Typography 
                variant="caption" 
                sx={{ 
                  fontWeight: 500,
                  fontSize: '0.7rem',
                  color: appMode === 'dark' ? '#fff' : '#1a1a1a',
                  lineHeight: 1.2,
                  textAlign: 'center'
                }}
              >
                {item.title}
              </Typography>
            </Paper>
      </Grid>
        ))}
      </Grid>
        </Box>
  );
}